import { Trans, useTranslation } from "react-i18next";
import { Form } from "antd/lib";
import HeroIconSrc from "shared/assets/images/hero-icon.png";
import { HeroSteps } from "./Hero";
import { Select } from "antd";
import { MaskInput } from "shared/components";
import { useSelector } from "react-redux";
import SingleMultiselect, {
  filterOptionDiacritics,
} from "shared/components/single-multiselect/SingleMultiselect";
import { useEffect } from "react";
import {
  dataLayerViewedEvent,
  tagManagerEvent,
} from "event-tracker/gtm-events";
import { validatePhone } from "shared/helpers/phone-helpers";

interface Props {
  setCurrentStep: any;
  form: any;
}

const filterGenreOptions = (
  options: any[],
  countryCode: string,
  valueToHide: string
) => {
  if (countryCode === "BR") {
    return options.filter((option) => option.value !== valueToHide);
  }
  return options;
};

const HeroDetails: React.FC<Props> = (props) => {
  const { setCurrentStep, form } = props;
  const { t } = useTranslation();
  const countryCode = Form.useWatch("countryCode", form);
  const genreCodes = Form.useWatch("genreCodes", form);
  const phone = Form.useWatch("phone", form);
  const { countryOptions } = useSelector((state: any) => state.countries);
  const { genreOptions } = useSelector((state: any) => state.genres);
  const filteredGenreOptions = filterGenreOptions(
    genreOptions,
    countryCode,
    "BR"
  );

  const onClickContinue = async () => {
    if (await form?.validateFields()) {
      setCurrentStep(HeroSteps.SignUp);
    }
  };

  useEffect(() => {
    dataLayerViewedEvent({
      ...tagManagerEvent.Hero.S4A_HERO_DETAILS,
    });
  }, []);

  return (
    <div className="details full-height">
      <div
        className="background-default"
        style={{
          backgroundImage: `url(${HeroIconSrc})`,
        }}
      >
        <div style={{ padding: "0 40px" }}>
          <p className="body-regular">
            <Trans i18nKey={t("pages.StrmHero.confirmInfo")} />
          </p>
          <Form.Item
            name="genreCodes"
            label={t("quiz.pages.Questionario.genreLabel")}
            rules={[
              {
                required: true,
                message: t("quiz.pages.Questionario.genreRequired"),
              },
            ]}
          >
            <SingleMultiselect
              style={{ width: "100%" }}
              options={filteredGenreOptions}
              optionFilterProp="label"
            />
          </Form.Item>
          <Form.Item
            name="countryCode"
            label={t("quiz.pages.Questionario.countryLabel")}
          >
            <Select
              showSearch
              options={countryOptions}
              filterOption={filterOptionDiacritics}
              notFoundContent={t("quiz.pages.Questionario.noItem")}
              style={{ width: "100%" }}
            />
          </Form.Item>
          <Form.Item
            name="phone"
            label={t("quiz.pages.Questionario.phoneLabel")}
            rules={[
              {
                required: true,
                message: t("quiz.pages.Questionario.phoneRequired"),
              },
              {
                validator(_, value) {
                  return validatePhone(
                    countryCode,
                    value,
                    t("pages.MeusDados.telefoneInvalido")
                  );
                },
              },
            ]}
          >
            <MaskInput
              mask={
                countryCode === "BR"
                  ? "(99) 9999-999999"
                  : "+99 (99) 9999-999999"
              }
              placeholder={
                countryCode === "BR"
                  ? "(99) 9999-999999"
                  : "+99 (99) 9999-999999"
              }
              maskChar=" "
            />
          </Form.Item>
        </div>
      </div>
      <div className="footer">
        <button
          className="botao-roxo"
          onClick={onClickContinue}
          type="button"
          disabled={
            !genreCodes || genreCodes.length === 0 || !countryCode || !phone
          }
          style={{ width: "100%" }}
        >
          {t("pages.StrmHero.continue")}
        </button>
      </div>
    </div>
  );
};

export default HeroDetails;
